module.exports = __webpack_public_path__ + "media/images/exp-thumb2-sm-ec38e5b1bfdc3cebb2a566ff570ecafa.png";